import { handleStatus500 } from 'api/Utility/HandleStatus500'
import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'
import apiWrapper from 'api/Utility/ApiWrapper'

const axiosRequest = (extraParams: any = {}) => {
  const params = {
    token: getToken(),
    ...extraParams,
  }

  return AxiosInitializer({
    ...params,
  })
}

const signupFormResponseEndpoint = {
  updateSignupFormResponse: (data: IndexType) => {
    const { params, userId } = data
    const url = `/site_users/${userId}/signup_form_response`
    return axiosRequest().put(url, params)
  },
}
const signupFormResponseAPI = (params: {
  params: { data: { attributes: { signup_form_response: IndexType } } }
  userId: any
}) =>
  apiWrapper({
    endPoint: signupFormResponseEndpoint.updateSignupFormResponse,
    params,
    errorFailureAction: handleStatus500,
  })

export default signupFormResponseAPI
